import { useState, useEffect } from 'react'

let lastId = 1

/**
 * Generate a unique ID. Useful for input IDs in forms.
 * @param prefix Optional prefix
 * @returns Unique ID
 */
export const useUniqueId = (prefix = 'uniqueId') => {
  const [id, setId] = useState('')

  useEffect(() => {
    setId(`${prefix}-${lastId++}`)
  }, [prefix])

  return id
}

export default useUniqueId
